import React from "react";
import { BrowserRouter, HashRouter } from "react-router-dom";
//  BrowserRouter,
import App from "../App";

const Root = () => (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

export default Root;
